import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { CouponsBenefitActivationDialogExtension } from './extension/coupons-benefit-activation-dialog.extension';
import { CouponsBenefitColumnsExtension } from './extension/coupons-benefit-columns.extension';
import { CouponsBenefitInfoTextExtension } from './extension/coupons-benefit-info-text.extension';
import { CouponsBenefitMetadataExtension } from './extension/coupons-benefit-metadata.extension';
import { CouponsBenefitNavigationExtension } from './extension/coupons-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('coupons')
    .add(BenefitMetadataExtensionInterface, new CouponsBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new CouponsBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new CouponsBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new CouponsBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new CouponsBenefitInfoTextExtension())
    .build(),
);
